import { Component } from "@angular/core";

@Component({
  selector: "app-account-layout",
  templateUrl: "./account-layout.component.html",
  styleUrls: ["./account-layout.component.scss"],
})
export class AccountLayoutComponent {}
